import Swiper from "swiper";
import {Pagination} from "swiper/modules";

export const history = () => {
  if (document.querySelector('.history')) {
    const slider = document.querySelectorAll('.history__slider');
    const wrapper = document.querySelectorAll('.history__items');
    const items = document.querySelectorAll('.history__item');

    items.forEach(item => {
      item.addEventListener('click', () => {
        items.forEach(subitem => {
          subitem.classList.remove('active');
        })
        item.classList.add('active');
      })
    })


    if (window.innerWidth <= 999) {
      slider.forEach((item) => {
        item.classList.add('swiper')
      })
      wrapper.forEach((item) => {
        item.classList.add('swiper-wrapper')
      })
      items.forEach((item) => {
        item.classList.add('swiper-slide')
      })


      slider.forEach((el, index) => {
        new Swiper(el, {
          modules: [Pagination],
          slidesPerView: 1,
          spaceBetween: 12,
          speed: 900,
        });
      });
    }
  }
}